export async function fetchEnv() {
  const rawEnv = await fetch('/env.json');
  return rawEnv.json();
}

export const getEnv = () =>
  fetchEnv()
    .catch(() => {
      // eslint-disable-next-line no-console
      console.error(
        'env.json is invalid. Please create a public/env.json from public/env.dist.json',
      );
      return null;
    })
    .then(env => ({
      ...env,
    }));

export default { getEnv, fetchEnv };
